import { useHasFreeUserLimit2 } from './auth';
export const useUserManagementUpgradeKey = () => {
  const hasFreeUserLimit2 = useHasFreeUserLimit2();
  return hasFreeUserLimit2 ? 'user-management-create-user-limit-free-v6' : 'user-management-create-user-limit';
};